/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEnum } from './RoleEnum';
import {
    RoleEnumFromJSON,
    RoleEnumFromJSONTyped,
    RoleEnumToJSON,
    RoleEnumToJSONTyped,
} from './RoleEnum';

/**
 *
 * @export
 * @interface InvitationDetails
 */
export interface InvitationDetails {
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly id: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly teamName: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly teamSlug: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly email: string;
    /**
     *
     * @type {RoleEnum}
     * @memberof InvitationDetails
     */
    readonly role: RoleEnum;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly invitedBy: string;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly isAccepted: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly isAuthenticated: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly userOwnsEmail: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly emailVerified: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly alreadyMember: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InvitationDetails
     */
    readonly canAccept: boolean;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly loginUrl: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly signupUrl: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly emailUrl: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly logoutUrl: string;
    /**
     *
     * @type {string}
     * @memberof InvitationDetails
     */
    readonly dashboardUrl: string;
}



/**
 * Check if a given object implements the InvitationDetails interface.
 */
export function instanceOfInvitationDetails(value: object): value is InvitationDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('teamSlug' in value) || value['teamSlug'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('invitedBy' in value) || value['invitedBy'] === undefined) return false;
    if (!('isAccepted' in value) || value['isAccepted'] === undefined) return false;
    if (!('isAuthenticated' in value) || value['isAuthenticated'] === undefined) return false;
    if (!('userOwnsEmail' in value) || value['userOwnsEmail'] === undefined) return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined) return false;
    if (!('alreadyMember' in value) || value['alreadyMember'] === undefined) return false;
    if (!('canAccept' in value) || value['canAccept'] === undefined) return false;
    if (!('loginUrl' in value) || value['loginUrl'] === undefined) return false;
    if (!('signupUrl' in value) || value['signupUrl'] === undefined) return false;
    if (!('emailUrl' in value) || value['emailUrl'] === undefined) return false;
    if (!('logoutUrl' in value) || value['logoutUrl'] === undefined) return false;
    if (!('dashboardUrl' in value) || value['dashboardUrl'] === undefined) return false;
    return true;
}

export function InvitationDetailsFromJSON(json: any): InvitationDetails {
    return InvitationDetailsFromJSONTyped(json, false);
}

export function InvitationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationDetails {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'teamName': json['team_name'],
        'teamSlug': json['team_slug'],
        'email': json['email'],
        'role': RoleEnumFromJSON(json['role']),
        'invitedBy': json['invited_by'],
        'isAccepted': json['is_accepted'],
        'isAuthenticated': json['is_authenticated'],
        'userOwnsEmail': json['user_owns_email'],
        'emailVerified': json['email_verified'],
        'alreadyMember': json['already_member'],
        'canAccept': json['can_accept'],
        'loginUrl': json['login_url'],
        'signupUrl': json['signup_url'],
        'emailUrl': json['email_url'],
        'logoutUrl': json['logout_url'],
        'dashboardUrl': json['dashboard_url'],
    };
}

  export function InvitationDetailsToJSON(json: any): InvitationDetails {
      return InvitationDetailsToJSONTyped(json, false);
  }

  export function InvitationDetailsToJSONTyped(value?: Omit<InvitationDetails, 'id'|'team_name'|'team_slug'|'email'|'role'|'invited_by'|'is_accepted'|'is_authenticated'|'user_owns_email'|'email_verified'|'already_member'|'can_accept'|'login_url'|'signup_url'|'email_url'|'logout_url'|'dashboard_url'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
